import React, { Component } from 'react';
import { faPause, faPlay, faSpinner, faArrowCircleRight, faArrowCircleLeft, faCompress, faVolume, faVolumeUp, faVolumeDown, faVolumeOff, faVolumeMute, faLocation, faSearchPlus, faSearchMinus, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Hls from 'hls.js';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Draggable from 'react-draggable';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var styles = {
  "container": "_3Zbwc",
  "containerRadio": "_1MBkJ",
  "radioElm": "_1yysw",
  "videoElm": "_26rYC",
  "controlBar": "_1-it4",
  "btn": "_25rEj",
  "info_container": "_3LXDP",
  "time__container": "_3oX6Y",
  "func_button": "_zBQdX",
  "close__button": "_2VNf4",
  "button__container": "_1aqAY",
  "playPauseBtn": "_Tf5yg",
  "speedBtn": "_3-glk",
  "leftBtn": "_1ImUE",
  "rightBtn": "_hUQUb",
  "volumeBtn": "_2sF6f",
  "fullBtn": "_96v4w",
  "playerInfos": "_3y8ur",
  "channelName": "_2580h",
  "timeStamp": "_13lOn"
};

function isNull(val) {
  return val === null;
}

function isUndefined(val) {
  return typeof val === 'undefined';
}

function isZero(val) {
  return val === 0;
}

function isNullOrUndefined(val) {
  return isNull(val) || isUndefined(val);
}

function isNullOrUndefinedOrZero(val) {
  return isNull(val) || isUndefined(val) || isZero(val);
}

var dateOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
};

var Media = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Media, _Component);

  function Media(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.hls = null;
    _this.interval = null;
    _this.pauseAt = undefined;
    _this.player = null;
    _this.streamerURL = _this.props.streamerURL || "https://streamer.yacast.fr/v0/public";

    _this.destroyAll = function () {
      if (_this.hls !== null) {
        _this.hls.detachMedia();

        _this.hls.destroy();

        _this.hls = null;
      }

      if (_this.interval !== null) {
        window.clearInterval(_this.interval);
        _this.interval = null;
      }
    };

    _this.restartAll = function () {
      if (!Hls.isSupported() || _this.player === null) {
        return;
      }

      _this.pauseAt = _this.props.pauseAt;
      _this.hls = new Hls({
        xhrSetup: function xhrSetup(xhr) {
          if (_this.player === null) {
            return;
          }

          if (!_this.props.shareToken) {
            xhr.setRequestHeader("authorization", "Bearer " + _this.props.aclToken);
          }

          xhr.setRequestHeader("x-yacast-streamer-client", "secure-player");
        }
      });
      var ts = Math.round(_this.props.start.getTime() / 1000);
      var end = Math.round(_this.props.start.getTime() / 1000 + _this.props.playerProps.timelineDuration);

      _this.hls.attachMedia(_this.player);

      _this.hlsBindings.forEach(function (callback, event) {
        _this.hls.on(event, callback);
      });

      _this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
        _this.interval = window.setInterval(function () {
          if (_this.player === null) {
            return;
          }

          var now = _this.start.getTime() + _this.player.currentTime * 1000;

          _this.setState({
            now: new Date(now)
          });
        }, 250);

        if (_this.player === null) {
          return;
        }

        _this.setState({
          ready: true
        });

        _this.player.playbackRate = _this.state.speed;
        _this.player.volume = _this.state.volume;

        if (_this.props.playing === true) {
          _this.player.play().then(function () {
            if (typeof _this.props.onPlayPause !== "undefined") {
              _this.props.onPlayPause(true);
            }
          })["catch"](function (err) {
            console.warn(err);

            _this.setState({
              ready: false
            });

            if (typeof _this.props.onPlayPause !== "undefined") {
              _this.props.onPlayPause(false);
            }
          });
        }
      });

      _this.player.ontimeupdate = function () {
        if (_this.player === null) {
          return;
        }

        var now = new Date(_this.props.start.getTime() + _this.player.currentTime * 1000);

        if (typeof _this.props.onTimeUpdate !== "undefined") {
          _this.props.onTimeUpdate(now);
        }

        if (typeof _this.pauseAt !== "undefined" && now.getTime() >= _this.pauseAt.getTime()) {
          _this.player.pause();

          _this.pauseAt = undefined;
        }
      };

      if (_this.props.shareToken) {
        _this.hls.loadSource(_this.streamerURL + "/share/" + _this.props.shareToken);

        return;
      }

      fetch("https://hyperion-public-api.yacast.fr/rest/v8/medias/available/" + _this.props.playerProps.mediaID, {
        method: "GET",
        mode: "cors",
        cache: "default"
      }).then(function (res) {
        return res.json();
      }).then(function (json) {
        if (_this.hls === null) {
          return;
        }

        if (json.sinceTimestamp === 0 || ts <= json.firstChunk) {
          var typeStr = "radio";

          switch (json.type) {
            case 2:
              typeStr = "tv";
              break;

            case 1:
            default:
              typeStr = "radio";
              break;
          }

          _this.hls.loadSource("https://ma-stream-dev.yacast.fr/" + typeStr + "/" + json.mediaSource + "/" + ts + "/master.m3u8");

          return;
        }

        _this.hls.loadSource(_this.streamerURL + "/instant?media=" + json.mediaSource + "&start=" + ts + "&end=" + end);
      })["catch"](function (err) {
        console.log(err);
      });
    };

    _this.startTimeHandler = function () {
      _this.setState(function (prevState) {
        return {
          startTime: prevState.now
        };
      }, function () {
        if (_this.props.onSelectTimeChange) {
          _this.props.onSelectTimeChange(_this.state.startTime, _this.state.endTime);
        }
      });
    };

    _this.endTimeHandler = function () {
      _this.setState(function (prevState) {
        return {
          endTime: prevState.now
        };
      }, function () {
        if (_this.props.onSelectTimeChange) {
          _this.props.onSelectTimeChange(_this.state.startTime, _this.state.endTime);
        }

        _this.onPlayPauseClick();
      });
    };

    _this.start = props.start;
    _this.hlsBindings = _this.getHLSBindings();
    _this.state = {
      mediaID: null,
      now: new Date(props.start),
      ready: false,
      speed: 1,
      volume: 0.75
    };
    return _this;
  }

  var _proto = Media.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.destroyAll();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.setState(function (_prevState, props) {
      return {
        mediaID: props.playerProps.mediaID
      };
    });
    this.restartAll();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var props_start = this.props.start;
    var this_start = this.start;

    if (this.player !== null) {
      if (this.props.playing === prevProps.playing && this.props.playing && this.player.paused) {
        this.setPlaying(false);
        this.player.pause();
      }

      if (this.props.playing === prevProps.playing && !this.props.playing && !this.player.paused) {
        this.setPlaying(true);
        this.player.play();
      }

      if (this.props.playing !== prevProps.playing && this.props.playing && this.player.paused) {
        this.player.play();
      }

      if (this.props.playing !== prevProps.playing && !this.props.playing && !this.player.paused) {
        this.player.pause();
      }
    }

    if (this_start.valueOf() !== props_start.valueOf()) {
      this.destroyAll();
      this.start = props_start;

      if (this.props.playerProps.mediaID !== this.state.mediaID) {
        this.setState(function (_prevState, props) {
          return {
            mediaID: props.playerProps.mediaID
          };
        }, this.restartAll);
      } else {
        this.restartAll();
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var speedText = "1x";

    switch (this.state.speed) {
      case 5:
        speedText = "5x";
        break;

      case 2:
        speedText = "2x";
        break;

      case 1:
        speedText = "1x";
        break;

      case 0.5:
      default:
        speedText = "½x";
        break;
    }

    var volumeIcon = faVolume;

    switch (this.state.volume) {
      case 0:
        volumeIcon = faVolumeMute;
        break;

      case 0.25:
        volumeIcon = faVolumeOff;
        break;

      case 0.5:
        volumeIcon = faVolumeDown;
        break;

      case 1:
        volumeIcon = faVolumeUp;
        break;

      case 0.75:
      default:
        volumeIcon = faVolume;
        break;
    }

    var hours = this.state.now.getHours();
    var minutes = this.state.now.getMinutes();
    var seconds = this.state.now.getSeconds();
    var exposeMedia = this.props.exposeMedia;
    return React.createElement("div", {
      className: this.props.playerProps.radioDisplay ? styles.containerRadio : styles.container
    }, React.createElement("video", {
      onClick: function onClick() {
        return _this2.onPlayPauseClick();
      },
      className: this.props.playerProps.radioDisplay ? styles.radioElm : styles.videoElm,
      ref: function ref(player) {
        if (player !== _this2.player && player !== null && player !== undefined && !isNullOrUndefined(exposeMedia)) {
          exposeMedia(player);
        }

        _this2.player = player;
        return player;
      }
    }), React.createElement("div", {
      className: styles.controlBar
    }, React.createElement("div", {
      className: classNames(styles.btn, styles.playPauseBtn),
      onClick: this.onPlayPauseClick.bind(this)
    }, this.state.ready ? this.props.playing ? React.createElement(FontAwesomeIcon, {
      icon: faPause
    }) : React.createElement(FontAwesomeIcon, {
      icon: faPlay
    }) : React.createElement(FontAwesomeIcon, {
      spin: true,
      icon: faSpinner
    })), React.createElement("div", {
      className: classNames(styles.btn, styles.speedBtn),
      onClick: this.onSpeedClick.bind(this)
    }, React.createElement("span", null, speedText)), React.createElement("div", {
      className: classNames(styles.btn, styles.rightBtn),
      onClick: this.startTimeHandler.bind(this)
    }, React.createElement(FontAwesomeIcon, {
      icon: faArrowCircleRight
    })), React.createElement("div", {
      className: classNames(styles.btn, styles.leftBtn),
      onClick: this.endTimeHandler.bind(this)
    }, React.createElement(FontAwesomeIcon, {
      icon: faArrowCircleLeft
    })), React.createElement("div", {
      className: classNames(styles.btn, styles.volumeBtn),
      onClick: this.onVolumeClick.bind(this)
    }, React.createElement(FontAwesomeIcon, {
      icon: volumeIcon
    })), React.createElement("div", {
      className: classNames(styles.btn, styles.fullBtn),
      onClick: this.onFSClick.bind(this)
    }, React.createElement(FontAwesomeIcon, {
      icon: faCompress
    })), React.createElement("div", {
      className: styles.playerInfos
    }, React.createElement("span", {
      className: styles.channelName
    }, this.props.playerProps.mediaName), React.createElement("span", {
      className: styles.timeStamp
    }, "le\xA0", this.state.now.toLocaleDateString("fr-FR", dateOptions), "\xA0\xE0\xA0", hours < 10 ? "0" : "", hours, ":", minutes < 10 ? "0" : "", minutes, ":", seconds < 10 ? "0" : "", seconds))));
  };

  _proto.setPlaying = function setPlaying(playing) {
    this.props.updatePlay(playing);
  };

  _proto.onPlayPauseClick = function onPlayPauseClick() {
    var _this3 = this;

    if (this.player === null || !this.state.ready) {
      return;
    }

    if (this.player.paused) {
      this.player.play().then(function () {
        _this3.setPlaying(true);

        if (typeof _this3.props.onPlayPause !== "undefined") {
          _this3.props.onPlayPause(true);
        }
      })["catch"](function (err) {
        console.warn(err);

        _this3.setPlaying(false);

        _this3.setState({
          ready: false
        });

        if (typeof _this3.props.onPlayPause !== "undefined") {
          _this3.props.onPlayPause(false);
        }
      });
    } else {
      this.player.pause();
      this.setPlaying(false);

      if (typeof this.props.onPlayPause !== "undefined") {
        this.props.onPlayPause(false);
      }
    }
  };

  _proto.onSpeedClick = function onSpeedClick() {
    var speed = 1;

    switch (this.state.speed) {
      case 5:
        speed = 0.5;
        break;

      case 2:
        speed = 5;
        break;

      case 1:
        speed = 2;
        break;

      case 0.5:
      default:
        speed = 1;
        break;
    }

    this.setState({
      speed: speed
    });

    if (this.player !== null && this.state.ready) {
      this.player.playbackRate = speed;
    }
  };

  _proto.onFragChange = function onFragChange(_, data) {
    if (isNullOrUndefined(data) || isNullOrUndefined(data.frag) || isNullOrUndefinedOrZero(data.frag.programDateTime)) {
      console.warn({
        data: data
      }, "Invalid Fragment change data");
      return;
    }

    var fragTime = new Date(data.frag.programDateTime);

    if (isNullOrUndefined(this.props.playerProps.start)) {
      console.warn({
        data: data
      }, "Frag change but no startAt ...");
      return;
    }

    {
      this.firstFragTime = fragTime;
      var currentTime = (this.props.start.getTime() - fragTime.getTime()) / 1000;
      var valid = false;

      for (var i = 0; i < this.player.buffered.length; i++) {
        if (currentTime >= this.player.buffered.start(i) && currentTime <= this.player.buffered.end(i)) {
          valid = true;
          break;
        }
      }

      if (!valid && this.player !== null) {
        currentTime = this.player.buffered.start(this.player.buffered.length - 1);
      }
    }
  };

  _proto.onVolumeClick = function onVolumeClick() {
    var volume = 0.75;

    switch (this.state.volume) {
      case 1:
        volume = 0;
        break;

      case 0:
        volume = 0.25;
        break;

      case 0.25:
        volume = 0.5;
        break;

      case 0.75:
        volume = 1;
        break;

      case 0.5:
      default:
        volume = 0.75;
        break;
    }

    this.setState({
      volume: volume
    });

    if (this.player !== null && this.state.ready) {
      this.player.volume = volume;
    }
  };

  _proto.onFSClick = function onFSClick() {
    if (this.player === null) {
      return;
    }

    this.player.requestFullscreen();
  };

  _proto.getHLSBindings = function getHLSBindings() {
    var bindings = new Map();
    bindings.set(Hls.Events.ERROR, this.onHLSError.bind(this));
    bindings.set(Hls.Events.FRAG_CHANGED, this.onFragChange.bind(this));
    return bindings;
  };

  _proto.onHLSError = function onHLSError(data) {};

  return Media;
}(Component);

var styles$1 = {
  "container": "_3sVga",
  "program": "_MuDap",
  "tooltip": "_BfY6X"
};

var Readjusted = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Readjusted, _Component);

  function Readjusted(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.tooltipId = '';
    _this.state = {
      tooltipPlace: 'right'
    };
    _this.tooltipId = "readjustedTooltip_" + (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    return _this;
  }

  var _proto = Readjusted.prototype;

  _proto.render = function render() {
    var _this2 = this;

    this.draw();
    return React.createElement("div", {
      className: styles$1.container,
      onMouseMove: this.onMouseMove.bind(this),
      ref: function ref(c) {
        _this2.container = c;
      }
    }, this.draw(), React.createElement(ReactTooltip, {
      className: styles$1.tooltip,
      id: this.tooltipId,
      place: this.state.tooltipPlace
    }));
  };

  _proto.draw = function draw() {
    var _this3 = this;

    if (this.container === null) {
      return [];
    }

    var elements = [];
    this.props.epg.forEach(function (epg) {
      var realStart = new Date(epg.start * 1000);
      var start = realStart;
      var realEnd = new Date(start.getTime() + epg.durationMS);
      var end = realEnd;

      if (realEnd.getTime() <= _this3.props.timelineStart.getTime() || realStart.getTime() >= _this3.props.timelineStart.getTime() + _this3.props.timelineDuration * 1000) {
        return;
      }

      if (realStart.getTime() <= _this3.props.timelineStart.getTime()) {
        start = _this3.props.timelineStart;
      }

      if (realEnd.getTime() >= _this3.props.timelineStart.getTime() + _this3.props.timelineDuration * 1000) {
        end = new Date(_this3.props.timelineStart.getTime() + _this3.props.timelineDuration * 1000);
      }

      var left = (start.getTime() - _this3.props.timelineStart.getTime()) / (_this3.props.timelineDuration * 1000);
      var width = (end.getTime() - start.getTime()) / (_this3.props.timelineDuration * 1000);
      elements.push(React.createElement("div", {
        className: styles$1.program,
        "data-for": _this3.tooltipId,
        "data-html": true,
        "data-tip": epg.title + '<br />' + epg.categoryText,
        key: "program_" + epg.start + "_" + epg.durationMS,
        onClick: _this3.clickProgram.bind(_this3, start),
        style: {
          backgroundColor: _this3.getReadjustedCategoryColor(epg.categoryText),
          left: left * 100 + "%",
          width: width * 100 + "%"
        }
      }, epg.title));
    });
    return elements;
  };

  _proto.getReadjustedCategoryColor = function getReadjustedCategoryColor(category) {
    switch (category.substr(0, 1)) {
      case 'A':
        {
          return '#2BA0FF';
        }

      case 'B':
        {
          return '#C2BE8C';
        }

      case 'C':
        {
          return '#F63AFC';
        }

      case 'D':
        {
          return '#FFDD00';
        }

      case 'E':
        {
          return '#3EBA00';
        }

      case 'F':
        {
          return '#B2F202';
        }

      case 'G':
        {
          return '#FAA5EA';
        }

      case 'H':
        {
          return '#C375FF';
        }

      case 'I':
        {
          return '#ABA893';
        }

      case 'J':
        {
          return '#B8CFDB';
        }

      default:
        return '#dddddd';
    }
  };

  _proto.clickProgram = function clickProgram(start, ev) {
    if (typeof this.props.onSetStart !== 'undefined') {
      ev.preventDefault();
      ev.stopPropagation();
      var s = new Date(start.getTime() + 8000);
      this.props.onSetStart(s);
    }
  };

  _proto.onMouseMove = function onMouseMove(ev) {
    var place = ev.currentTarget === null || typeof ev.currentTarget.getBoundingClientRect() === 'undefined' || ev.clientX / ev.currentTarget.getBoundingClientRect().width < 0.5 ? 'right' : 'left';
    this.setState(_extends({}, this.state, {
      tooltipPlace: place
    }));
  };

  return Readjusted;
}(Component);

var styles$2 = {
  "container": "_3_QxJ",
  "tick": "_1dzE9",
  "timeText": "_1Eie8"
};

var Time = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Time, _Component);

  function Time() {
    return _Component.apply(this, arguments) || this;
  }

  Time.getRanges = function getRanges() {
    return [[30, 10], [60, 20], [300, 60], [3600, 1200], [7200, 1200]];
  };

  var _proto = Time.prototype;

  _proto.render = function render() {
    var _this = this;

    this.draw();
    return React.createElement("div", {
      className: styles$2.container,
      ref: function ref(c) {
        _this.container = c;
      }
    }, this.draw());
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var active = "ticker_range_" + this.props.tickRanges[0] + "_" + this.props.tickRanges[1];
    Time.getRanges().forEach(function (values) {
      var current = "ticker_range_" + values[0] + "_" + values[1];
      Array.from(document.getElementsByClassName(current)).forEach(function (element) {
        element.style.display = current === active ? 'block' : 'none';
      });
    });
  };

  _proto.draw = function draw() {
    var _this2 = this;

    if (this.container === null) {
      return [];
    }

    var res = [];
    Time.getRanges().forEach(function (values) {
      var className = "ticker_range_" + values[0] + "_" + values[1];
      res.push(_this2.drawTickEvery(values[0], 2, 25, className));
      res.push(_this2.drawTickEvery(values[1], 1, 10, className));
      res.push(_this2.drawText(values[0], className));
    });
    return res;
  };

  _proto.drawTickEvery = function drawTickEvery(seconds, width, height, className) {
    var duration = this.props.timelineDuration;
    var left = 0;
    var key = 1;
    var elements = [];

    for (var i = 0; i <= duration; i += seconds) {
      elements.push(React.createElement("div", {
        className: styles$2.tick + ' ' + className,
        key: "tick_" + key++ + "_" + seconds,
        style: {
          borderWidth: width,
          height: height,
          left: left * 100 + "%"
        }
      }));
      left += seconds / this.props.timelineDuration;
    }

    return elements;
  };

  _proto.drawText = function drawText(interval, className) {
    var time = this.props.timelineStart.getTime();
    var duration = this.props.timelineDuration;
    var left = 0;
    var elements = [];
    var key = 1;

    for (var i = 0; i <= duration; i += interval) {
      var date = new Date(time);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      var text = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      elements.push(React.createElement("div", {
        className: styles$2.timeText + ' ' + className,
        key: "timeText_" + key++ + "_" + interval,
        style: {
          left: left * 100 + "%"
        }
      }, text));
      time += interval * 1000;
      left += interval / this.props.timelineDuration;
    }

    return elements;
  };

  return Time;
}(Component);

var styles$3 = {
  "container": "_35Pdt",
  "container__music": "_1PPtY",
  "program": "_1uYMH",
  "root": "_2Da1T",
  "popover": "_aHcJI",
  "popoverCover": "_18P3J",
  "line": "_lFLN9",
  "cursor": "_3XIUk",
  "hoverCursor": "_231K0",
  "selection": "_36txJ",
  "selectionStart": "_2R4Hi",
  "selectionEnd": "_3o0Pk",
  "selectionDrag": "_3Zk3c",
  "lines": "_1sgUD",
  "tooltip": "_3-FG3"
};
var IDEAL_STEP_WIDTH = 160;

var Timeline = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Timeline, _Component);

  function Timeline(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.container = null;
    _this.containerCheckInterval = 0;
    _this.cursor = null;
    _this.dragModeEnabled = false;
    _this.hoverCursor = null;
    _this.lastContainerWidth = 0;
    _this.ready = false;
    _this.selectionDraggingMode = "";
    _this.tooltipId = "";
    _this.tooltipText = "";

    _this.updateSelection = function (start, end) {
      _this.setState({
        selectionStart: start,
        selectionEnd: end
      }, _this.refreshSelection);
    };

    _this.tooltipId = "timeTooltip_" + (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    _this.state = {
      declarativeEPG: [],
      musicEPG: [],
      readjustedEPG: [],
      readjustedEPG2: [],
      selectionEnd: typeof _this.props.playerProps.selectionEnd === "undefined" ? null : _this.props.playerProps.selectionEnd,
      selectionLeft: -1,
      selectionStart: typeof _this.props.playerProps.selectionStart === "undefined" ? null : _this.props.playerProps.selectionStart,
      selectionWidth: -1,
      viewport: 0,
      zoom: 1
    };

    if (typeof _this.props.playerProps.onSelectionChange !== "undefined") {
      _this.dragModeEnabled = true;
    }

    return _this;
  }

  var _proto = Timeline.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.containerCheckInterval !== 0) {
      window.clearInterval(this.containerCheckInterval);
      this.containerCheckInterval = 0;
    }

    if (this.container === null) {
      return;
    }

    this.lastContainerWidth = this.container.getBoundingClientRect().width;
    this.setState({
      viewport: this.lastContainerWidth
    });
    this.containerCheckInterval = window.setInterval(function () {
      if (_this2.container === null) {
        return;
      }

      var viewport = _this2.container.getBoundingClientRect().width;

      if (_this2.lastContainerWidth !== viewport) {
        _this2.setState({
          viewport: viewport
        });
      }

      _this2.lastContainerWidth = viewport;
    }, 1000);
    window.setTimeout(function () {
      _this2.refreshSelection();

      _this2.ready = true;
    }, 1000);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.containerCheckInterval !== 0) {
      window.clearInterval(this.containerCheckInterval);
      this.containerCheckInterval = 0;
    }

    this.lastContainerWidth = 0;
  };

  _proto.render = function render() {
    var _this3 = this;

    var minHeight = 50;

    if (this.state.declarativeEPG.length > 0) {
      minHeight += 25;
    }

    if (this.state.readjustedEPG.length > 0) {
      minHeight += 25;
    }

    if (this.state.readjustedEPG2.length > 0) {
      minHeight += 25;
    }

    if (this.state.musicEPG.length > 0) {
      minHeight += 25;
    }

    return React.createElement("div", {
      className: styles$3.container,
      onMouseDown: this.onMouseDown.bind(this),
      onMouseLeave: this.onMouseLeave.bind(this),
      onMouseMove: this.onMouseMove.bind(this),
      onMouseUp: this.onMouseUp.bind(this),
      ref: function ref(e) {
        _this3.container = e;
      },
      style: {
        minHeight: minHeight
      }
    }, React.createElement(ReactTooltip, {
      className: styles$3.tooltip,
      getContent: function getContent() {
        return _this3.tooltipText;
      },
      id: this.tooltipId,
      overridePosition: this.overrideTooltipPosition.bind(this)
    }), React.createElement("div", {
      className: styles$3.lines,
      "data-for": this.tooltipId,
      "data-html": true,
      "data-tip": "",
      onClick: this.onTimeClick.bind(this),
      style: {
        width: this.props.timelineDuration / this.computeSecondsByPixel()
      },
      onMouseLeave: this.onMouseLinesLeave.bind(this),
      onMouseMove: this.onMouseLinesMove.bind(this)
    }, React.createElement("div", {
      className: styles$3.cursor,
      style: {
        left: this.getCursorX()
      },
      ref: function ref(c) {
        return _this3.cursor = c;
      }
    }), React.createElement("div", {
      className: styles$3.hoverCursor,
      ref: function ref(c) {
        return _this3.hoverCursor = c;
      }
    }), this.state.selectionLeft >= 0 && this.state.selectionWidth >= 0 ? React.createElement("div", {
      className: styles$3.selection,
      style: {
        left: this.state.selectionLeft,
        width: this.state.selectionWidth
      }
    }) : "", this.state.selectionLeft >= 0 && this.state.selectionWidth >= 0 ? React.createElement("div", {
      className: styles$3.selectionStart + (this.dragModeEnabled ? " " + styles$3.selectionDrag : ""),
      "data-type": "selectionStart",
      style: {
        left: this.state.selectionLeft
      }
    }) : "", this.state.selectionLeft >= 0 && this.state.selectionWidth >= 0 ? React.createElement("div", {
      className: styles$3.selectionEnd + (this.dragModeEnabled ? " " + styles$3.selectionDrag : ""),
      "data-type": "selectionEnd",
      style: {
        left: this.state.selectionLeft + this.state.selectionWidth
      }
    }) : "", React.createElement(Time, {
      secondsByPixel: this.computeSecondsByPixel(),
      tickRanges: this.computeRanges(),
      timelineDuration: this.props.timelineDuration,
      timelineStart: this.props.timelineStart
    }), this.state.readjustedEPG.length > 0 ? React.createElement(Readjusted, {
      epg: this.state.readjustedEPG,
      onSetStart: this.props.onSetStart,
      tickRanges: this.computeRanges(),
      timelineDuration: this.props.timelineDuration,
      timelineStart: this.props.timelineStart
    }) : "", this.state.readjustedEPG2.length > 0 ? React.createElement(Readjusted, {
      epg: this.state.readjustedEPG2,
      onSetStart: this.props.onSetStart,
      tickRanges: this.computeRanges(),
      timelineDuration: this.props.timelineDuration,
      timelineStart: this.props.timelineStart
    }) : "", this.state.musicEPG.length > 0 ? React.createElement(Readjusted, {
      epg: this.state.musicEPG,
      onSetStart: this.props.onSetStart,
      tickRanges: this.computeRanges(),
      timelineDuration: this.props.timelineDuration,
      timelineStart: this.props.timelineStart
    }) : ""));
  };

  _proto.setViewport = function setViewport(viewport) {
    this.setState({
      viewport: viewport
    });
    this.refreshSelection();
  };

  _proto.center = function center() {
    if (this.container === null) {
      return;
    }

    var left = this.getCursorX() - this.state.viewport / 2;
    this.container.scrollLeft = left < 0 ? 0 : left;
  };

  _proto.centerSelection = function centerSelection() {
    if (this.container === null) {
      return;
    }

    if (this.props.playerProps.selectionStart === undefined || this.props.playerProps.selectionEnd === undefined) {
      return;
    }

    var center = this.getselectionStartX() + (this.getselectionEndX() - this.getselectionStartX()) / 2;
    var left = center - this.state.viewport / 2;
    this.container.scrollLeft = left < 0 ? 0 : left;
  };

  _proto.setZoom = function setZoom(zoom) {
    this.setState({
      zoom: zoom
    });
    this.props.updateZoom(zoom);
    this.refreshSelection();
    this.center();
  };

  _proto.getCursorX = function getCursorX() {
    var x = (this.props.currentTime.getTime() - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();

    if (this.ready && typeof this.props.onEndReach !== "undefined") {
      var end = this.props.timelineStart.getTime() + this.props.timelineDuration * 1000;

      if (this.props.currentTime.getTime() >= end) {
        this.props.onEndReach();
      }
    }

    return x;
  };

  _proto.getselectionStartX = function getselectionStartX() {
    if (this.props.playerProps.selectionStart === undefined) {
      return this.getCursorX();
    }

    var x = (this.props.playerProps.selectionStart.getTime() - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();
    return x;
  };

  _proto.getselectionEndX = function getselectionEndX() {
    if (this.props.playerProps.selectionEnd === undefined) {
      return this.getCursorX();
    }

    var x = (this.props.playerProps.selectionEnd.getTime() - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();
    return x;
  };

  _proto.computeRanges = function computeRanges() {
    var spx = this.computeSecondsByPixel();
    var ranges = Time.getRanges();
    var range = ranges[ranges.length - 1];
    ranges.some(function (testedRange) {
      if (testedRange[0] / spx >= IDEAL_STEP_WIDTH) {
        range = testedRange;
        return true;
      }

      return false;
    });
    return range;
  };

  _proto.computeSecondsByPixel = function computeSecondsByPixel() {
    return this.props.timelineDuration / (this.state.viewport * this.state.zoom);
  };

  _proto.refreshSelection = function refreshSelection(notify) {
    if (notify === void 0) {
      notify = false;
    }

    if (this.state.selectionStart === null || this.state.selectionEnd === null) {
      return;
    }

    var selectionLeft = (this.state.selectionStart.getTime() - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();
    var selectionWidth = (this.state.selectionEnd.getTime() - this.state.selectionStart.getTime()) / 1000 / this.computeSecondsByPixel();
    this.setState({
      selectionLeft: selectionLeft,
      selectionWidth: selectionWidth
    });

    if (notify && typeof this.props.playerProps.onSelectionChange !== "undefined") {
      this.props.playerProps.onSelectionChange(this.state.selectionStart, this.state.selectionEnd);
    }
  };

  _proto.onTimeClick = function onTimeClick(ev) {
    if (typeof this.props.onSetStart === "undefined") {
      return;
    }

    var bound = ev.currentTarget.getBoundingClientRect();
    var ts = this.props.timelineStart.getTime() + this.props.timelineDuration * (ev.pageX - bound.x) / this.getWidth() * 1000;
    this.props.onSetStart(new Date(Math.floor(ts / 1000) * 1000));

    if (this.cursor !== null) {
      var px = (Math.floor(ts / 1000) * 1000 - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();
      this.cursor.style.left = px + "px";
    }
  };

  _proto.getWidth = function getWidth() {
    return this.props.timelineDuration / this.computeSecondsByPixel();
  };

  _proto.onMouseLinesLeave = function onMouseLinesLeave() {
    if (this.hoverCursor === null) {
      return;
    }

    this.hoverCursor.style.display = "none";
    this.hoverCursor.style.left = "0px";
  };

  _proto.onMouseLinesMove = function onMouseLinesMove(ev) {
    if (ev.currentTarget === null) {
      return;
    }

    if (this.tooltip !== null) {
      ReactTooltip.show(this.tooltip);
    }

    var bound = ev.currentTarget.getBoundingClientRect();
    var time = new Date(this.props.timelineStart.getTime() + this.props.timelineDuration * ((ev.pageX - bound.x) / this.getWidth()) * 1000);
    var x = (time.getTime() - this.props.timelineStart.getTime()) / 1000 / this.computeSecondsByPixel();
    this.tooltipText = this.getTimeString(time);

    if (this.hoverCursor !== null) {
      this.hoverCursor.style.display = "block";
      this.hoverCursor.style.left = x + "px";
    }
  };

  _proto.overrideTooltipPosition = function overrideTooltipPosition(position) {
    var pos = position;

    if (this.container !== null) {
      pos.top = this.container.offsetTop - 3;
    }

    return pos;
  };

  _proto.getTimeString = function getTimeString(date) {
    var res = "";
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var ms = date.getMilliseconds();
    res += (hours < 10 ? "0" : "") + hours;
    res += ":";
    res += (minutes < 10 ? "0" : "") + minutes;
    res += ":";
    res += (seconds < 10 ? "0" : "") + seconds;
    res += ".";
    res += (ms < 10 ? "00" : ms < 100 ? "0" : "") + ms;
    return res;
  };

  _proto.onMouseDown = function onMouseDown(ev) {
    var type = ev.target.getAttribute("data-type");

    if (!this.dragModeEnabled || type !== "selectionStart" && type !== "selectionEnd") {
      return;
    }

    ev.preventDefault();
    ev.stopPropagation();
    this.selectionDraggingMode = type;
  };

  _proto.onMouseLeave = function onMouseLeave() {
    this.selectionDraggingMode = "";
  };

  _proto.onMouseMove = function onMouseMove(ev) {
    if (ev.currentTarget !== null && this.selectionDraggingMode !== "") {
      var container = ev.currentTarget;
      var x = container.scrollLeft + (ev.clientX - container.getBoundingClientRect().x);
      var ratio = x / container.scrollWidth;
      var date = new Date(this.props.timelineStart.getTime() + this.props.timelineDuration * 1000 * ratio);
      var state = this.state;
      state = this.selectionDraggingMode === "selectionStart" ? _extends({}, state, {
        selectionStart: date
      }) : _extends({}, state, {
        selectionEnd: date
      });
      this.state = state;
      this.refreshSelection(true);
    }
  };

  _proto.onMouseUp = function onMouseUp() {
    this.selectionDraggingMode = "";
  };

  return Timeline;
}(Component);

var styles$4 = {
  "container1": "_32XFA",
  "container2": "_3OEP_",
  "button": "_1xECG",
  "button2": "_Bio7K",
  "firstLine": "_2GOd5",
  "titleLine": "_1thqk",
  "left1": "_15hVr",
  "left2": "_3-azQ",
  "buttonPlaySelection": "_lbGqs",
  "buttonCenterCursor": "_1LdQr",
  "buttonZoomIn": "_2lKeM",
  "center": "_1DYho",
  "slider": "_2Xtb1",
  "sliderTrack": "_uqJ9Q",
  "sliderTrackActive": "_ownBx",
  "sliderCursor": "_pdstO",
  "right": "_1mSaw"
};

var Toolbar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Toolbar, _Component);

  function Toolbar(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.container = null;
    _this.containerCheckInterval = 0;
    _this.dragTimer = 0;
    _this.lastContainerWidth = 0;
    _this.tooltipId = "";
    _this.zoom = 1;
    _this.state = {
      maxZoom: 1,
      currentZoom: 0
    };
    _this.tooltipId = "zoomTooltip_" + (Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    return _this;
  }

  var _proto = Toolbar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.containerCheckInterval !== 0) {
      window.clearInterval(this.containerCheckInterval);
      this.containerCheckInterval = 0;
    }

    if (this.container === null) {
      return;
    }

    this.lastContainerWidth = this.container.getBoundingClientRect().width;
    this.recomputeMaxZoom(this.lastContainerWidth);
    this.setState(_extends({}, this.state, {
      maxZoom: this.recomputeMaxZoom(this.lastContainerWidth)
    }));
    this.containerCheckInterval = window.setInterval(function () {
      if (_this2.container === null) {
        return;
      }

      var viewport = _this2.container.getBoundingClientRect().width;

      if (_this2.lastContainerWidth !== viewport) {
        _this2.setState(_extends({}, _this2.state, {
          maxZoom: _this2.recomputeMaxZoom(viewport)
        }));
      }

      _this2.lastContainerWidth = viewport;
    }, 1000);

    if (typeof this.props.playerProps.initialZoom !== "undefined" && (this.props.playerProps.selectionZoom !== true || typeof this.props.playerProps.selectionStart === "undefined" || typeof this.props.playerProps.selectionEnd === "undefined")) {
      window.setTimeout(function () {
        if (typeof _this2.props.playerProps.initialZoom === "undefined" || _this2.props.playerProps.initialZoom <= 0 || _this2.container === null) {
          return;
        }

        _this2.setZoom(_this2.props.playerProps.initialZoom >= 1 ? 1 : _this2.props.playerProps.initialZoom, true);
      }, 1000);
    }

    if (typeof this.props.playerProps.selectionStart !== "undefined" && typeof this.props.playerProps.selectionEnd !== "undefined") {
      window.setTimeout(function () {
        if (_this2.props.playerProps.selectionZoom === true) {
          _this2.setZoom80pOnSelection();
        }

        window.setTimeout(function () {
          if (typeof _this2.props.onCenterSelection !== "undefined") {
            _this2.props.onCenterSelection();
          }
        }, 250);
      }, 1000);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.containerCheckInterval !== 0) {
      window.clearInterval(this.containerCheckInterval);
      this.containerCheckInterval = 0;
    }

    this.lastContainerWidth = 0;
  };

  _proto.render = function render() {
    var _this3 = this;

    return React.createElement("div", {
      className: this.props.playerProps.selectionStart === undefined || this.props.playerProps.selectionEnd === undefined ? styles$4.container1 : styles$4.container2,
      ref: function ref(e) {
        _this3.container = e;
      }
    }, this.props.playerProps.selectionStart === undefined || this.props.playerProps.selectionEnd === undefined ? "" : React.createElement("div", {
      className: styles$4.titleLine
    }, React.createElement("div", {
      className: styles$4.left1
    }, React.createElement("span", null, "curseur")), React.createElement("div", {
      className: styles$4.left2
    }, React.createElement("span", null, "selection"))), React.createElement("div", {
      className: styles$4.firstLine
    }, React.createElement("div", {
      className: styles$4.left1
    }, React.createElement("a", {
      className: styles$4.button + " " + styles$4.buttonCenterCursor,
      onClick: function onClick() {
        if (typeof _this3.props.onCenter !== "undefined") {
          _this3.props.onCenter();
        }
      },
      title: "Centrer sur le curseur"
    }, React.createElement(FontAwesomeIcon, {
      icon: faLocation
    })), React.createElement("a", {
      className: styles$4.button,
      onClick: this.zoomIn.bind(this),
      title: "Zoomer (shift pour zoom rapide)"
    }, React.createElement(FontAwesomeIcon, {
      icon: faSearchPlus
    })), React.createElement("a", {
      className: styles$4.button + " " + styles$4.buttonZoomIn,
      onClick: this.zoomOut.bind(this),
      title: "D\xE9zoomer (shift pour zoom rapide)"
    }, React.createElement(FontAwesomeIcon, {
      icon: faSearchMinus
    }))), this.props.playerProps.selectionStart === undefined || this.props.playerProps.selectionEnd === undefined ? "" : React.createElement("div", {
      className: styles$4.left2
    }, React.createElement("a", {
      className: styles$4.button + " " + styles$4.buttonCenterCursor,
      onClick: function onClick() {
        if (typeof _this3.props.onCenterSelection !== "undefined") {
          _this3.props.onCenterSelection();
        }
      },
      title: "Centrer sur la s\xE9lection"
    }, React.createElement(FontAwesomeIcon, {
      icon: faLocation
    })), React.createElement("a", {
      className: styles$4.button + " " + styles$4.buttonZoomIn,
      onClick: this.setZoom80pOnSelection.bind(this),
      title: "zoom 80% selection"
    }, React.createElement(FontAwesomeIcon, {
      icon: faSearch
    }))), React.createElement("div", {
      className: styles$4.center
    }, React.createElement("div", {
      className: styles$4.slider,
      onClick: this.onSliderClick.bind(this),
      ref: function ref(_ref) {
        return _this3.sliderElm = _ref;
      }
    }, React.createElement("div", {
      className: styles$4.sliderTrack
    }), React.createElement("div", {
      className: styles$4.sliderTrackActive,
      ref: function ref(_ref2) {
        return _this3.sliderTrackActiveElm = _ref2;
      }
    }), React.createElement(Draggable, {
      axis: "x",
      bounds: "parent",
      defaultPosition: {
        x: 0,
        y: 0
      },
      grid: [1, 1],
      handle: "#handle_" + this.tooltipId,
      ref: function ref(_ref3) {
        return _this3.cursorElm = _ref3;
      },
      scale: 1,
      onDrag: this.onDragZoom.bind(this)
    }, React.createElement("div", {
      className: styles$4.sliderCursor,
      "data-for": this.tooltipId,
      "data-tip": "",
      id: "handle_" + this.tooltipId
    })), React.createElement(ReactTooltip, {
      id: this.tooltipId,
      getContent: function getContent() {
        return _this3.zoom + "x";
      }
    })))));
  };

  _proto.setZoom80pOnSelection = function setZoom80pOnSelection() {
    var _this4 = this;

    if (typeof this.props.playerProps.selectionStart === "undefined" || typeof this.props.playerProps.selectionEnd === "undefined") {
      return;
    }

    if (this.props.selectionDuration / this.props.timelineDuration >= 0.8) {
      this.setZoom(0, false);

      if (typeof this.props.onCenterSelection !== "undefined") {
        this.props.onCenterSelection();
      }

      return;
    }

    if (this.props.selectionDuration * this.props.maxPixelsPerSecond <= 0.8 * this.lastContainerWidth) {
      this.setZoom(1, false);

      if (typeof this.props.onCenterSelection !== "undefined") {
        this.props.onCenterSelection();
      }

      return;
    }

    var percentSelectionOverTimeline = this.props.selectionDuration / this.props.timelineDuration;
    var ratio = 0.8 / percentSelectionOverTimeline;
    var zoom = Math.log(ratio) / Math.log(this.state.maxZoom);
    this.setZoom(zoom, false);
    window.setTimeout(function () {
      if (typeof _this4.props.onCenterSelection !== "undefined") {
        _this4.props.onCenterSelection();
      }
    }, 250);
  };

  _proto.setZoom = function setZoom(value, updateCursor) {
    var _this5 = this;

    value = value < 0 ? 0 : value > 1 ? 1 : value;
    var percent = value * 100;
    this.setState(_extends({}, this.state, {
      currentZoom: value
    }));
    value = Math.round(Math.exp(Math.log(this.state.maxZoom) * value));

    if (value === this.zoom) {
      return;
    }

    this.zoom = value;

    if (this.dragTimer !== 0) {
      window.clearTimeout(this.dragTimer);
      this.dragTimer = 0;
    }

    if (typeof this.props.onChangeZoom !== "undefined") {
      this.dragTimer = window.setTimeout(function () {
        if (typeof _this5.props.onChangeZoom !== "undefined") {
          _this5.props.onChangeZoom(value);
        }
      }, 250);
    }

    if (this.sliderElm !== null && this.cursorElm !== null) {
      if (updateCursor) {
        var box = this.sliderElm.getBoundingClientRect();
        var x = Math.round((box.width - 10) * (percent / 100));
        this.cursorElm.setState(_extends({}, this.cursorElm.state, {
          x: x
        }));
      }

      if (this.sliderTrackActiveElm !== null) {
        this.sliderTrackActiveElm.style.width = percent + "%";
      }
    }
  };

  _proto.onDragZoom = function onDragZoom(_, data) {
    if (this.sliderElm === null) {
      return;
    }

    var box = this.sliderElm.getBoundingClientRect();

    if (box.width <= 10) {
      return;
    }

    this.setZoom(data.x / (box.width - 10), false);
  };

  _proto.zoomOut = function zoomOut(ev) {
    var _this6 = this;

    ev.preventDefault();
    var delta = ev.shiftKey ? 0.1 : 0.05;

    if (ev.ctrlKey) {
      this.setZoom(this.state.currentZoom - delta, false);
      window.setTimeout(function () {
        if (typeof _this6.props.onCenterSelection !== "undefined") {
          _this6.props.onCenterSelection();
        }
      }, 250);
    } else {
      this.setZoom(this.state.currentZoom - delta, true);
    }

    return false;
  };

  _proto.zoomIn = function zoomIn(ev) {
    var _this7 = this;

    ev.preventDefault();
    var delta = ev.shiftKey ? 0.1 : 0.05;

    if (ev.ctrlKey) {
      this.setZoom(this.state.currentZoom + delta, false);
      window.setTimeout(function () {
        if (typeof _this7.props.onCenterSelection !== "undefined") {
          _this7.props.onCenterSelection();
        }
      }, 250);
    } else {
      this.setZoom(this.state.currentZoom + delta, true);
    }

    return false;
  };

  _proto.onSliderClick = function onSliderClick(ev) {
    var elem = ev.target;

    if (this.sliderElm === null || elem.hasAttribute("data-tip")) {
      return;
    }

    ev.preventDefault();
    ev.stopPropagation();
    var bound = this.sliderElm.getBoundingClientRect();
    this.setZoom((ev.clientX - bound.x) / bound.width, true);
  };

  _proto.computeSecondsByPixel = function computeSecondsByPixel(viewport) {
    if (this.props.timelineDuration <= 0 || viewport <= 0) {
      return 0;
    }

    return this.props.timelineDuration / viewport;
  };

  _proto.recomputeMaxZoom = function recomputeMaxZoom(viewport) {
    var maxPixelsPerSecond = this.props.maxPixelsPerSecond;
    var spp = this.computeSecondsByPixel(viewport);
    var sppMin = 1 / maxPixelsPerSecond;
    var max = 1;

    for (max = 1; max < 4000; max++) {
      if (spp / max <= sppMin) {
        break;
      }
    }

    return max;
  };

  return Toolbar;
}(Component);

var styles$5 = {
  "containerVideoFull": "_1zk04",
  "containerRadioOnly": "_37NAy"
};

var YacastPlayer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(YacastPlayer, _Component);

  function YacastPlayer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.autoplay = false;
    _this.endReachedTimer = 0;
    _this.pauseAt = undefined;
    _this.timeline = null;
    _this.switchTimer = -1;
    _this.maxPixelsPerSecond = _this.props.maxPixelsPerSecond === undefined ? 150 : _this.props.maxPixelsPerSecond < 10 ? 10 : _this.props.maxPixelsPerSecond > 500 ? 500 : _this.props.maxPixelsPerSecond;

    _this.updateSelection = function (start, end) {
      if (_this.timeline) {
        _this.timeline.updateSelection(start, end);
      }
    };

    _this.updateZoom = function (value) {
      _this.setState({
        timelineZoom: value
      });
    };

    _this.updatePlay = function (playing) {
      _this.setState({
        playing: playing
      });
    };

    _this.state = {
      currentTime: props.start,
      fastForward: 0,
      timelineZoom: 1,
      playing: props.autoplay === true,
      start: props.start,
      timelineStart: _this.getTimelineStart(),
      timelineEnd: _this.getTimelineEnd()
    };
    _this.autoplay = props.autoplay === true;
    _this.keyboardHandler = _this.handleKeyboardEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = YacastPlayer.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return React.createElement("div", {
      className: styles$5.containerVideoFull,
      id: "container_media_timeline_toolbox"
    }, React.createElement(Media, {
      aclToken: this.props.aclToken,
      autoplay: this.autoplay,
      currentTime: this.state.currentTime,
      exposeMedia: this.props.exposeMedia,
      key: this.state.start.getTime(),
      onPlayPause: this.props.onPlayPause,
      onSelectTimeChange: this.props.onSelectTimeChange,
      onTimeUpdate: this.onTimeUpdate.bind(this),
      pauseAt: this.pauseAt,
      playerProps: this.props,
      playing: this.state.playing,
      shareToken: this.props.shareToken,
      start: this.state.start,
      streamerURL: this.props.streamerURL,
      updatePlay: this.updatePlay
    }), this.props.videoOnly ? "" : this.props.lightPlayer ? "" : React.createElement(Toolbar, {
      onChangeZoom: this.onChangeZoom.bind(this),
      onCenter: this.onCenter.bind(this),
      onCenterSelection: this.onCenterSelection.bind(this),
      onPlaySelection: this.onPlaySelection.bind(this),
      playerProps: this.props,
      timelineDuration: this.getTimelineDuration(),
      selectionDuration: this.getSelectionDuration(),
      maxPixelsPerSecond: this.maxPixelsPerSecond
    }), this.props.videoOnly ? "" : React.createElement(Timeline, {
      currentTime: this.state.currentTime,
      onEndReach: this.onEndReach.bind(this),
      onSetStart: this.onSetStartAndCurrentTime.bind(this),
      playerProps: this.props,
      ref: function ref(_ref) {
        return _this2.timeline = _ref;
      },
      timelineEnd: this.state.timelineEnd,
      timelineStart: this.state.timelineStart,
      timelineDuration: this.getTimelineDuration(),
      updateZoom: this.updateZoom
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("keydown", this.keyboardHandler);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("keydown", this.keyboardHandler);
  };

  _proto.getTimelineDuration = function getTimelineDuration() {
    var selectionDuration = this.getSelectionDuration();

    if (typeof this.props.timelineDuration === "undefined" && selectionDuration === 0) {
      return 60;
    }

    if (this.props.timelineDuration < 60 && selectionDuration < 60) {
      return 60;
    }

    if (selectionDuration > this.props.timelineDuration) {
      return selectionDuration;
    }

    if (this.props.timelineDuration > 86400) {
      return 86400;
    }

    return Math.round(this.props.timelineDuration);
  };

  _proto.getSelectionDuration = function getSelectionDuration() {
    if (typeof this.props.selectionStart !== "undefined" && typeof this.props.selectionEnd !== "undefined") {
      return Math.round((this.props.selectionEnd.getTime() - this.props.selectionStart.getTime()) / 1000);
    }

    return 0;
  };

  _proto.getSelectionMiddle = function getSelectionMiddle() {
    if (typeof this.props.selectionStart !== "undefined" && typeof this.props.selectionEnd !== "undefined") {
      return new Date(this.props.selectionStart.getTime() + (this.props.selectionEnd.getTime() - this.props.selectionStart.getTime()) / 2);
    }

    return undefined;
  };

  _proto.getTimelineStart = function getTimelineStart() {
    var selectionDuration = this.getSelectionDuration();
    var timelineDuration = this.getTimelineDuration();
    var selectionMiddle = this.getSelectionMiddle();

    if (selectionDuration !== 0 && typeof selectionMiddle !== "undefined") {
      return new Date(selectionMiddle.getTime() - timelineDuration * 1000 / 2);
    }

    return new Date(this.props.start.getTime() - timelineDuration * 1000 / 2);
  };

  _proto.getTimelineEnd = function getTimelineEnd() {
    var selectionDuration = this.getSelectionDuration();
    var timelineDuration = this.getTimelineDuration();
    var selectionMiddle = this.getSelectionMiddle();

    if (selectionDuration !== 0 && typeof selectionMiddle !== "undefined") {
      return new Date(selectionMiddle.getTime() + timelineDuration * 1000 / 2);
    }

    return new Date(this.props.start.getTime() + timelineDuration * 1000 / 2);
  };

  _proto.handleKeyboardEvent = function handleKeyboardEvent(ev) {
    if (ev.code === "Space") {
      ev.preventDefault();
      ev.stopPropagation();
      this.updatePlay(!this.state.playing);
    }

    if (ev.code === "ArrowRight" || ev.code === "ArrowLeft") {
      ev.preventDefault();
      ev.stopPropagation();
      var fff;

      if (ev.shiftKey) {
        fff = ev.code === "ArrowRight" ? 1000 / 25 : -1000 / 25;
      } else {
        fff = ev.code === "ArrowRight" ? 1000 : -1000;
      }

      var ff = this.state.fastForward + fff;
      this.setState({
        fastForward: ff
      });
      this.refreshStart();
    }
  };

  _proto.refreshStart = function refreshStart() {
    var _this3 = this;

    if (this.switchTimer !== -1) {
      window.clearTimeout(this.switchTimer);
    }

    this.switchTimer = window.setTimeout(function () {
      var ns = new Date(_this3.state.currentTime.getTime() + _this3.state.fastForward);

      _this3.onSetStart(ns);

      _this3.onTimeUpdate(ns);

      _this3.setState({
        fastForward: 0
      });

      _this3.switchTimer = -1;
    }, 300);
  };

  _proto.onChangeZoom = function onChangeZoom(zoom) {
    if (this.timeline !== null) {
      this.timeline.setZoom(zoom);
    }
  };

  _proto.onCenter = function onCenter() {
    if (this.timeline !== null) {
      this.timeline.center();
    }
  };

  _proto.onCenterSelection = function onCenterSelection() {
    if (this.timeline !== null) {
      this.timeline.centerSelection();
    }
  };

  _proto.onTimeUpdate = function onTimeUpdate(currentTime) {
    this.setState({
      currentTime: currentTime
    });

    if (typeof this.props.onDateUpdate !== "undefined") {
      this.props.onDateUpdate(currentTime);
    }
  };

  _proto.onSetStartAndCurrentTime = function onSetStartAndCurrentTime(start) {
    this.setState({
      start: start,
      currentTime: start
    });
  };

  _proto.onSetStart = function onSetStart(start, pauseAt) {
    this.pauseAt = pauseAt;
    this.setState({
      start: start
    });
  };

  _proto.onEndReach = function onEndReach() {
    var _this4 = this;

    if (this.endReachedTimer === 0) {
      this.endReachedTimer = window.setTimeout(function () {
        _this4.endReachedTimer = 0;
      }, 1000);
      this.autoplay = false;
      this.setState({
        start: this.props.start
      });
    }
  };

  _proto.onPlaySelection = function onPlaySelection() {
    if (typeof this.props.selectionStart === "undefined" || typeof this.props.selectionEnd === "undefined") {
      return;
    }

    this.autoplay = true;
    this.onSetStart(new Date(this.props.selectionStart), new Date(this.props.selectionEnd));
  };

  return YacastPlayer;
}(Component);

export { YacastPlayer };